var _templateObject = _taggedTemplateLiteralLoose(['\n  width: 0;\n  height: 0;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  border-right: ', ';\n  position: absolute;\n  top: 50%;\n  left: 43px;\n  margin-top: -2px;\n'], ['\n  width: 0;\n  height: 0;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  border-right: ', ';\n  position: absolute;\n  top: 50%;\n  left: 43px;\n  margin-top: -2px;\n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 0;\n  height: 0;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  border-left: 4px solid #f4f4f4;\n  position: absolute;\n  top: 50%;\n  right: 43px;\n  margin-top: -2px;\n'], ['\n  width: 0;\n  height: 0;\n  border-top: 4px solid transparent;\n  border-bottom: 4px solid transparent;\n  border-left: 4px solid #f4f4f4;\n  position: absolute;\n  top: 50%;\n  right: 43px;\n  margin-top: -2px;\n']);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

import React from 'react';
import styled from 'styled-components';

var LeftArrow = styled.span(_templateObject, function (props) {
  return props.user === 'BOT' ? '4px solid ' + props.theme.lightColor : '4px solid #f4f4f4';
});

var RightArrow = styled.span(_templateObject2);

var Arrow = function Arrow(_ref) {
  var user = _ref.user;
  return user === 'CUSTOMER' ? React.createElement(RightArrow, null) : React.createElement(LeftArrow, { user: user });
};

export default Arrow;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@hype/chatbot/es/components/message-list/message/arrow.js
// module id = 763
// module chunks = 1